export const SnapLogo = ({
  color,
  size,
}: {
  color?: string | undefined;
  size: number;
}) => (
  <svg width="100" height="50" viewBox="0 0 417 117">
    <path
      d="M0 0 C23.43 0 46.86 0 71 0 C71 24.09 71 48.18 71 73 C63.41 73 55.82 73 48 73 C48 55.51 48 38.02 48 20 C40.08 20 32.16 20 24 20 C24 37.49 24 54.98 24 73 C16.08 73 8.16 73 0 73 C0 48.91 0 24.82 0 0 Z "
      fill="#0000FF"
      transform="translate(346,42)"
    />
    <path
      d="M0 0 C23.43 0 46.86 0 71 0 C71 24.09 71 48.18 71 73 C63.41 73 55.82 73 48 73 C48 55.51 48 38.02 48 20 C39.75 20 31.5 20 23 20 C23 37.49 23 54.98 23 73 C15.41 73 7.82 73 0 73 C0 48.91 0 24.82 0 0 Z "
      fill="#0000FF"
      transform="translate(0,42)"
    />
    <path
      d="M0 0 C9.37555437 6.56106047 16.0055729 15.11084983 18.21875 26.40625 C19.55551028 36.9651542 17.52324034 46.77368995 11.69140625 55.71484375 C5.33957277 63.81343144 -3.78783762 69.70547837 -14.00390625 71.46875 C-28.0529672 72.96890397 -38.97095277 69.43675423 -50.49609375 61.52734375 C-58.16744496 53.85599254 -62.34855395 44.17439 -62.74609375 33.40234375 C-62.44065383 22.49559329 -58.9267482 13.55110487 -51.30859375 5.71484375 C-37.45797918 -7.1567253 -16.46763582 -9.16726258 0 0 Z M-36.68359375 21.15234375 C-40.15452481 26.62573504 -41.15661494 31.28491092 -40.30859375 37.71484375 C-38.65107063 43.26307981 -35.85471954 46.61005487 -31.08984375 49.8046875 C-26.94768924 51.92118312 -22.90677974 52.09802592 -18.30859375 51.71484375 C-12.43234693 49.75981867 -8.7644817 46.79703191 -5.30859375 41.71484375 C-2.83815416 36.66167186 -2.9868221 32.07911412 -4.30859375 26.71484375 C-7.16462538 21.21433838 -11.33380312 16.70644063 -17.30859375 14.71484375 C-25.11455911 13.77566449 -31.14990081 15.47302731 -36.68359375 21.15234375 Z "
      fill="#0000FF"
      transform="translate(314.30859375,45.28515625)"
    />
    <path
      d="M0 0 C7.92 0 15.84 0 24 0 C24 37.62 24 75.24 24 114 C16.08 114 8.16 114 0 114 C0 76.38 0 38.76 0 0 Z "
      fill="#0000FF"
      transform="translate(173,1)"
    />
    <path
      d="M0 0 C7.92 0 15.84 0 24 0 C24 37.62 24 75.24 24 114 C16.08 114 8.16 114 0 114 C0 76.38 0 38.76 0 0 Z "
      fill="#0000FF"
      transform="translate(131,1)"
    />
    <path
      d="M0 0 C7.59 0 15.18 0 23 0 C23 24.09 23 48.18 23 73 C15.41 73 7.82 73 0 73 C0 48.91 0 24.82 0 0 Z "
      fill="#0000FF"
      transform="translate(215,42)"
    />
    <path
      d="M0 0 C7.59 0 15.18 0 23 0 C23 24.09 23 48.18 23 73 C15.41 73 7.82 73 0 73 C0 48.91 0 24.82 0 0 Z "
      fill="#0000FF"
      transform="translate(90,42)"
    />
    <path
      d="M0 0 C3.81248738 1.31970717 5.66857107 2.63368381 8.375 5.625 C10.45494473 9.94488521 10.82730415 13.28943147 10 18 C8.19672394 21.74526566 6.67282723 23.54125416 3.25 25.875 C-0.68227005 27.2361704 -3.88862888 27.74677599 -8 27 C-11.85247583 24.96472975 -14.90224752 22.86428089 -17 19 C-18.48566947 13.37567987 -17.85712535 10.04758812 -15 5 C-10.15537894 0.50986341 -6.57295251 -0.66220044 0 0 Z "
      fill="#0000FF"
      transform="translate(105,1)"
    />
    <path
      d="M0 0 C3.95018626 2.08689086 6.64836078 4.21311966 9 8 C9.78623141 12.33737663 10.013156 16.96162661 8.015625 20.98046875 C5.79912839 23.75108952 3.41686088 26.02375403 0 27 C-5.58523668 27.45042231 -9.23153558 27.25122574 -14 24 C-17.05055526 20.62833366 -18.27403455 17.97411596 -18.5 13.5 C-18.27403455 9.02588404 -17.05055526 6.37166634 -14 3 C-9.53121083 -0.04690171 -5.28559605 -0.96005836 0 0 Z "
      fill="#0000FF"
      transform="translate(231,1)"
    />
  </svg>
);
